<template>
  <div v-if="isShowTips && isHome" class="top_tips">
    <span class="tips_title">"Request Early Access"</span>
    <span class="tips_content">
      <img class="tips_img" src="@/assets/images/hand_up.svg" />
      <div class="tips_text">
        <p>Private beta · Invitation only</p>
        <p>
          <img src="@/assets/images/tips_email.svg" />
          hello@joylanders.com
        </p>
      </div>
    </span>
    <span class="close_btn" @click="handleCloseTips">Okay, I'll take a look around first</span>
  </div>
  <div v-show="!isEditResume" class="header">
    <a href="" @click.prevent="linkToIndex" class="logo">
      <img src="@/assets/images/logo_header.png" alt="Logo" class=" logo_pc" />
      <img src="@/assets/images/logo_header_mobile.png" alt="Logo" class=" logo_moblie" />
    </a>
    <div class="right_wrapper">
      <div class="search_wrapper search_init_wrapper" v-if="isInitState && isHome">
        <div class="search">
          <div class="auto-complete-textarea">
            <a-textarea
              v-model:value="filterForm.words"
              name="search"
              placeholder="Search resumes"
              :auto-size="{ minRows: 1, maxRows: 1 }"
              class="search_input"
              @input="onInput"
              @keydown="handleKeydown"
            />
            <ul
              v-if="showSuggestions"
              class="suggestions_list"
              style="width: auto; min-width: 100%;"
              ref="suggestionsRef"
            >
              <li v-for="item in suggestions.slice(0, 10)" :key="item.job" @click="selectSuggestion(item)">
                <span class="skill">{{ item.job }}</span>
                <span class="position">{{ item.industry }}</span>
              </li>
            </ul>
          </div>
          <img src="@/assets/images/search.svg" alt="" class="search_icon" @click="handleInitSearch()" />
        </div>
      </div>
      <a href="/theater" class="link workplace_theater" target="_blank">
        <img class="link_icon icon_smile" src="@/assets/images/smile.svg" alt="" />
        Workplace Theater
      </a>
      <a v-if="!currentAccount.actualName" href="#" class="link login" @click.prevent="handleClickAuth">
        <img class="link_icon icon_user" src="@/assets/images/user.svg" alt="" />
        {{ hasAccount() ? 'Login' : 'Sign Up' }}
      </a>
      <template v-else>
        <a-dropdown trigger="click" placement="bottomRight">
          <span class="link">
            <img
              class="link_icon icon_user"
              :src="currentAccount.headUrl || '@/assets/images/user.svg'"
              alt=""
              @error="setDefaultImage"
            />
            {{ currentAccount.firstName + ' ' + currentAccount.lastName }}
          </span>
          <template #overlay>
            <div class="user_dropdown_wrapper">
              <div class="btn_wrapper">
                <a href="/userCenter" class="link_btn" target="_blank">
                  <img src="@/assets/images/profile.svg" alt="" />My Profile
                </a>
                <router-link class="link_btn logout_btn" @click="handleLogout" to="/">
                  <img src="@/assets/images/logout.svg" alt="" />Sign out
                </router-link>
              </div>
            </div>
          </template>
        </a-dropdown>
      </template>
    </div>
    <LoginModal
      ref="loginModalRef"
      @open-register="handleOpenRegister"
      @open-forgetPassword="handleOpenForgetPassword"
    />
    <ForgetPasswordModal ref="forgetPasswordModalRef" @open-login="handleOpenLogin" />
    <RegisterModal ref="registerModalRef" @open-login="handleOpenLogin" />
  </div>
</template>

<script setup>
import { message } from 'ant-design-vue';
import Cookies from 'js-cookie';
import { onMounted, ref, reactive, computed, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';

import ForgetPasswordModal from './ForgetPasswordModal.vue';
import RegisterModal from './RegisterModal.vue';

import { fetchCategoryTree, fetchCategoryList, fetchAccountInfo, logout } from '@/api/common.js';
import LoginModal from '@/components/LoginModal.vue';

const route = useRoute();
const router = useRouter();
const store = useStore();
const uploadURL = process.env.VUE_APP_UPLOAD_URL;
const loginModalRef = ref(null);
const registerModalRef = ref(null);
const forgetPasswordModalRef = ref(null);

const handleOpenLogin = () => {
  loginModalRef.value.open();
};

// 有账号标记（登录/注册成功过）→ 老用户开登录页；否则新用户开注册页
// 用函数而非ref：退出登录不刷新页面时，重渲染能读到最新localStorage值
const hasAccount = () => localStorage.getItem('hasAccount') === '1';
const handleClickAuth = () => {
  if (hasAccount()) {
    handleOpenLogin();
  } else {
    handleOpenRegister();
  }
};

const handleOpenRegister = () => {
  registerModalRef.value.open();
};

const handleOpenForgetPassword = () => {
  forgetPasswordModalRef.value.open();
};

const currentAccount = computed(() => store.state.currentAccount);
const navName = ref(route.name);

const isInitState = computed(() => store.state.isStoreInitState);
const isHome = computed(() => route.path === '/index');
const isEditResume = computed(() => route.path === '/userCenter/editResume');
const isShowTips = computed(() => store.state.isShowTips);

const showSuggestions = ref(false);
const suggestions = ref([]);
const autoCompleteOptions = ref([]);
const suggestionsRef = ref(null);

const filterForm = reactive({
  words: '',
});

const onInput = () => {
  showSuggestions.value = true;
  suggestions.value = autoCompleteOptions.value.filter((option) =>
    option.job.toLowerCase().includes(filterForm.words.toLowerCase())
  );
};

const handleKeydown = (event) => {
  if (event.key === 'Enter') {
    event.preventDefault();
    handleInitSearch();
  }
};

const handleInitSearch = () => {
  if (filterForm.words) {
    store.state.isStoreInitState = false;
    // 跳转到首页并执行搜索
    router.push({
      path: '/index',
      query: { search: filterForm.words },
    });
  } else {
    message.error('Please enter your content first.');
  }
};

const selectSuggestion = (item) => {
  filterForm.words = item.job + ' ' + item.industry;
  handleInitSearch();
};

const handleLogout = () => {
  logout().then((res) => {
    if (res.code == 0) {
      store.dispatch('logout', res.data);
      Cookies.remove('token');
      window.location.reload();
    } else {
      message.error(res.msg);
    }
  });
};

const linkToIndex = () => {
  if (isHome.value) {
    // 如果在首页，重置搜索状态而不是刷新页面
    store.state.isStoreInitState = true;
    // 清除URL中的search参数
    router.replace({ query: {} });
  } else {
    router.push('/index');
  }
};

const handleClickOutside = (event) => {
  if (suggestionsRef.value && !suggestionsRef.value.contains(event.target)) {
    showSuggestions.value = false;
  }
};

const handleCloseTips = () => {
  store.state.isShowTips = false;
  // store 初始值从 localStorage 读取（'false' 表示已确认不再展示），
  // 这里必须同步写入，否则刷新/重进后提示条会再次出现
  localStorage.setItem('isShowTips', 'false');
};

const setDefaultImage = (event) => {
  event.target.src = require('@/assets/images/user.svg');
};

const getAccountInfo = () => {
  fetchAccountInfo().then((res) => {
    if (res.code == 0) {
      store.commit('setCurrentAccount', res.data);
    } else {
      // 拉取用户信息失败基本都是登录态失效/被顶，给出明确提示而非空 msg
      message.error(res.msg || 'Your session has expired, please log in again.');
      store.dispatch('logout', res.data);
      Cookies.remove('token');
      router.push('/index');
    }
  });
};

const getCategoryTree = () => {
  fetchCategoryTree().then((res) => {
    if (res.code == 0) {
      store.state.categoryTree = res.data;
    } else {
      message.error(res.msg);
    }
  });
};

const getCategoryList = () => {
  fetchCategoryList().then((res) => {
    if (res.code == 0) {
      store.state.categoryList = res.data;
      // 初始化自动完成选项
      autoCompleteOptions.value = [
        ...res.data.jobList.map((item) => ({
          job: item.job,
          industry: item.industry,
        })),
        ...res.data.skillList.map((skill) => ({
          job: skill,
          industry: '',
        })),
      ];
    } else {
      message.error(res.msg);
    }
  });
};

watch(route, (newRoute) => {
  navName.value = newRoute.name;
});

onMounted(() => {
  const urlParams = new URLSearchParams(window.location.search);
  const token = urlParams.get('token') || '';
  if (store.getters.isAuthenticated && !(token && route.path === '/userCenter/editResume')) {
    getAccountInfo();
  }
  getCategoryTree();
  getCategoryList();
  document.addEventListener('click', handleClickOutside);
});
</script>

<style lang="less" scoped>
.top_tips {
  background: #f78335;
  display: flex;
  justify-content: center;
  color: #fff;
  font-weight: bold;
  align-items: center;
  gap: 10px;
  height: 80px;
  padding: 0 20px;
  .tips_title {
    font-size: 16px;
  }
  .tips_content {
    display: flex;
    align-items: center;
    .tips_img {
      width: 70px;
      height: 70px;
      margin-bottom: -10px;
    }
    .tips_text {
      margin-left: 10px;
      p {
        display: flex;
        align-items: center;
        font-size: 14px;
        margin-bottom: 8px;
        img {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
      }
    }
  }
  .close_btn {
    color: #572300;
    border-radius: 100px;
    background: #ffbe3f;
    padding: 12px 20px;
    cursor: pointer;
    margin-left: 20px;
    white-space: nowrap;
  }
  @media (max-width: 1080px) {
    height: auto;
    padding: 16px 12px;
    flex-wrap: wrap;
    gap: 12px;
    .tips_title {
      font-size: 14px;
      width: 100%;
      text-align: center;
    }
    .tips_content {
      .tips_img {
        width: 50px;
        height: 50px;
      }
      .tips_text {
        margin-left: 8px;
        p {
          font-size: 13px;
          margin-bottom: 6px;
        }
      }
    }
    .close_btn {
      font-size: 13px;
      padding: 10px 16px;
      margin-left: 0;
      width: 100%;
      text-align: center;
    }
  }
  @media (max-width: 640px) {
    .tips_title {
      font-size: 13px;
    }
    .tips_content {
      // 手机端内容整体居中，文案行也居中，避免"图偏左、文字块挤在中间"的散乱感
      justify-content: center;
      align-items: center;
      .tips_img {
        width: 36px;
        height: 36px;
        margin-bottom: 0; // 桌面为底部对齐留的负 margin，窄屏改为垂直居中
      }
      .tips_text {
        margin-left: 8px;
        p {
          font-size: 12px;
          justify-content: center;
          margin-bottom: 4px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
    }
    .close_btn {
      font-size: 12px;
      padding: 8px 14px;
    }
  }
}
.header {
  padding: 10px 30px;
  width: 100%;
  position: relative;
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .logo {
    cursor: pointer;
    .logo_pc,
    .logo_moblie {
      display: none;
    }
    .logo_pc {
      @media (min-width: 1080px) {
        display: block;
        width: 266px;
        height: auto;
      }
    }
    .logo_moblie {
      @media (max-width: 1080px) {
        display: block;
        width: 120px;
        height: auto;
      }
    }
  }
  .search_wrapper {
    margin: 32px auto;
    display: flex;
    max-width: 1080px;
    position: relative;
    justify-content: center;
    align-items: center;
    .search {
      flex: 1;
      position: relative;
      background: #fff;
      border-radius: 20px;
      padding: 16px;
      max-width: 850px;
      .search_input {
        border: none;
        box-shadow: none;
        color: #05644f;
        font-size: 14px;
        padding: 0;
        &::placeholder {
          color: rgba(5, 100, 79, 0.3);
        }
      }
      .search_icon {
        width: 20px;
        height: 20px;
        position: absolute;
        right: 20px;
        bottom: 15px;
        cursor: pointer;
      }
    }
    .suggestions_list {
      position: absolute;
      background: #ffffff;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
      border-radius: 8px;
      width: auto;
      min-width: 100%;
      top: 100%;
      left: 0;
      z-index: 1000;
      li {
        list-style: none;
        padding: 10px 20px;
        color: #05644f;
        font-size: 16px;
        cursor: pointer;
        white-space: nowrap;
        &:hover {
          background: rgba(5, 100, 79, 0.1);
        }
        .position {
          margin-left: 20px;
          color: rgba(5, 100, 79, 0.5);
        }
      }
    }
  }
  .search_init_wrapper {
    margin: 4px 20px 0;
    min-width: 200px;
    width: auto;
    height: 40px;
    position: relative;
    z-index: 100;
    display: flex;
    align-items: center;
    .search {
      padding: 8px 16px;
      min-width: 200px;
      width: auto;
      .search_icon {
        bottom: 10px;
      }
    }
  }
  .right_wrapper {
    display: flex;
    align-items: center;
    gap: 20px;
    .link {
      color: #05644f;
      font-size: 14px;
      text-decoration: none;
      line-height: 50px;
      margin: 0 10px;
      cursor: pointer;
      .link_icon {
        margin-right: 5px;
        &.icon_smile {
          width: 24px;
          height: 24px;
          vertical-align: middle;
        }
        &.icon_user {
          width: 32px;
          height: 32px;
          border-radius: 50%;
        }
      }
    }
  }
}

/* 真机窄屏（initial-scale=1，视口即设备 CSS 宽）：
   第一行 logo + Theater + 登录，第二行搜索框通栏 */
@media (max-width: 640px) {
  .header {
    flex-wrap: wrap;
    padding: 10px 12px;
    row-gap: 10px;
    .logo {
      order: 1;
      .logo_moblie {
        width: 90px;
      }
    }
    .right_wrapper {
      display: contents; // 子项提升为 header 的 flex 项，便于搜索框独占一行
      .link {
        line-height: normal;
        align-self: center;
        white-space: nowrap;
      }
      > .link {
        order: 3;
        margin: 0;
        font-size: 13px;
        .link_icon {
          margin-right: 4px;
          &.icon_user {
            width: 28px;
            height: 28px;
          }
        }
      }
      .workplace_theater {
        order: 2;
        margin-left: auto;
        margin-right: 12px;
        font-size: 12px;
        .icon_smile {
          width: 20px;
          height: 20px;
        }
      }
    }
    .search_wrapper.search_init_wrapper {
      order: 4;
      flex: 0 0 100%;
      width: 100%;
      min-width: 0;
      margin: 0;
      .search {
        width: 100%;
        min-width: 0;
      }
    }
  }
}
</style>

<style lang="less">
.user_dropdown_wrapper {
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.3);
  width: 200px;
  padding: 10px 0;
  a {
    color: #05644f;
    font-size: 16px;
    display: block;
    padding: 10px;
    img {
      width: 15px;
      height: 15px;
      margin: 0 10px;
    }
    &:hover {
      background: rgba(5, 100, 79, 0.1);
    }
  }
}
</style>
